export let ContentTagInputType=/*#__PURE__*/function(ContentTagInputType){ContentTagInputType["MULTI_SELECT"]="multi-select";return ContentTagInputType;}({});